import { cloudFunction } from '../parse';

export const getSubscriptionInventoryItems = async (params) => {
  return cloudFunction('getSubscriptionInventoryItems', params);
};

export const removeSubscriptionInventoryItem = async (subscriptionInventoryItemId: string) => {
  return cloudFunction('removeSubscriptionInventoryItem', { subscriptionInventoryItemId });
};

export const addSubscriptionInventoryItem = async (params: {subscriptionId: string; inventoryItemId: string; quantity: number}) => {
  return cloudFunction('addSubscriptionInventoryItem', params);
};

export const updateSubscriptionInventoryItem = async (params: {id: string; quantity: number}) => {
  return cloudFunction('updateSubscriptionInventoryItem', params);
};